import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap"
import ButtonLoading from "../components/ButtonLoading"
import InputTag from "../components/InputTag"
import imgPhotogrid from "../assets/img/photogrid-example.jpg"
import { PhotoProvider, PhotoView } from 'react-photo-view';
import ImageUploader from "../components/ImageUploader"
import SweetAlert from "../components/SweetAlert"
import DateRangePicker from "react-bootstrap-daterangepicker"
import moment from "moment"
import http, { getUserFacingError } from "../services/http"
import Select from "react-select";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import FileUploader from "../components/FileUploader"
import { MdClose } from "react-icons/md"
import { readAuthUser } from "../services/sessionStorage"
import { applicationService } from "../services/applicationService"

const month = [
    { label: "Januari", value: "01" },
    { label: "Februari", value: "02" },
    { label: "Maret", value: "03" },
    { label: "April", value: "04" },
    { label: "Mei", value: "05" },
    { label: "Juni", value: "06" },
    { label: "Juli", value: "07" },
    { label: "Agustus", value: "08" },
    { label: "September", value: "09" },
    { label: "Oktober", value: "10" },
    { label: "November", value: "11" },
    { label: "Desember", value: "12" }
]

type Job = {
    position: string;
    company_name: string;
    start_month: string;
    start_year: string;
    end_month: string;
    end_year: string;
    jobdesc: string;
    isNew?: boolean;
}

type PositionLoker = {
    position_loker_id: number;
    position_loker_name: string;
}

type AuthUserProfile = {
    fullname?: string;
    email?: string;
    phone?: string;
}

const sortPositionLokers = (items: PositionLoker[] = []) => {
    return [...items].sort((a, b) => String(a.position_loker_name || '').localeCompare(
        String(b.position_loker_name || ''),
        'id',
        { sensitivity: 'base' }
    ))
}

const TalentForm = () => {
    const navigate = useNavigate()
    const [queryParameters] = useSearchParams()
    const [position, setPosition] = useState<PositionLoker[]>([])
    const { jobId } = useParams<{ jobId?: string }>()
    const [jobInfo, setJobInfo] = useState<{ title: string; status: string } | null>(null)
    const [jobClosed, setJobClosed] = useState(false)
    const [form, setForm] = useState<any>({
        fullname: "",
        email: "",
        age: "",
        gender: "",
        birth_date: "",
        domicile: "",
        socmed_url : "",
        phone: "",
        position: [],
        position_loker_ids: [],
        height: "",
        weight: "",
        // skill: [],
        description: "",
        resource: "",
        photo: "",
        agreement: false,
        agreement2: false,
        cv: "",
        education_level: "",
        education_major: "",
        education_institute: "",
        education_location: "",
        education_year_end: ""
    })
        const [job, setJob] = useState<Job[]>([
      {
        position: "",
        company_name: "",
        start_month: "",
        start_year: "",
        end_month: "",
        end_year: "",
        jobdesc: ""
      }
    ])
    const [loading, setLoading] = useState(false)
    const [profileCheckLoading, setProfileCheckLoading] = useState(true)
    const profileApplyAttemptedRef = useRef(false)
    const [city, setCity] = useState([])

    const yearRange = (startYear:number) => {
        var currentYear = new Date().getFullYear(), years = [];
        startYear = startYear || 1980;  
        while ( startYear <= currentYear ) {
            years.push(currentYear--);
        }   
        return years;
    }

    const loadCity = () =>  {
        http.get(`public/city`, {
            params: {
                order: [
                    {
                        field: 'ms_city_name',
                        sort: 'asc'
                    }
                ]
            }
        })
        .then((res) => {
            setCity(res.data.data.map((item:any) => ({ value: item.ms_city_id, label: item.ms_city_name })))
        })
    }

    const loadPosition = (resolvedJobId?: string) =>  {
        const id = resolvedJobId || jobId || queryParameters.get('job_id')
        if (id) {
            // Fetch only positions linked to this job
            http.get(`public/jobs/${id}/positions`)
                .then((res) => {
                    const data = res.data.data
                    if (Array.isArray(data) && data.length > 0) {
                        setPosition(sortPositionLokers(data))
                    } else {
                        // Fallback: job has no specific positions, load all
                        http.get(`public/position_loker`, {
                            params: { filter: [{ field: 'status', operator: '=', value: '1' }] }
                        }).then((r) => setPosition(sortPositionLokers(r.data.data)))
                    }
                })
        } else {
            http.get(`public/position_loker`, {
                params: { filter: [{ field: 'status', operator: '=', value: '1' }] }
            }).then((res) => setPosition(sortPositionLokers(res.data.data)))
        }
    }

    const onSubmit = (e:any) => {
        e.preventDefault()
        e.stopPropagation()

        if (jobClosed) {
            SweetAlert({
                icon: 'warning',
                text: 'Maaf, lowongan ini sudah ditutup dan tidak menerima pendaftar baru.'
            })
            return
        }

        if (!validateJob()) {
            setTimeout(() => {
                const jobSection = document.querySelector('.job-history-section');
                if (jobSection) {
                    jobSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
            return
        }

        // Run validation on main form fields
        if (!validateBeforeSubmit()) {
            return
        }

        setLoading(true)

        http.post(`public/talent-register`, {
            name: form.fullname,
            email: form.email,
            phone: form.phone,
            resources: form.resource,
            age: form.age,
            height: form.height,
            weight: form.weight,
            // skill: form.skill.toString(),
            domicile: form.domicile,
            birth_date: form.birth_date,
            socmed_url: form.socmed_url,
            position: form.position_loker_ids.map((id:any) => {
                const item = position.find((p:any) => p.position_loker_id === id)
                return item?.position_loker_name || ''
            }).filter(Boolean).join(','),
            position_loker_ids: form.position_loker_ids,
            primary_position_loker_id: form.position_loker_ids[0] || null,
            description: form.description,
            photogrid: form.photo,
            gender: form.gender,
            cv: form.cv,
            level: form.education_level,
            major: form.education_major,
            institute: form.education_institute,
            location: form.education_location,
            year_end: form.education_year_end,
            jobs: job.map((x, i) => ({
                company_name: x.company_name,
                position: x.position,
                join_date: `${x.start_year}-${x.start_month}-01`,
                end_date: `${x.end_year}-${x.end_month}-01`,
                jobdesc: x.jobdesc,
            })),
            tag: queryParameters.get('tag'),
            job_id: jobId ? Number(jobId) : null
        }).then((res) => {
            if (res.data.status) {
                navigate("/terima-kasih", {
                    state: {
                        key: "talent-form",
                        jobId: jobId ? Number(jobId) : null,
                        outsourceId: res.data.outsource_id ?? res.data.data?.outsource_id ?? null,
                        applicationId: res.data.application_id ?? null,
                    }
                })
            } else {
                SweetAlert({
                    icon: 'error',
                    text: res.data.message || 'Oops.. Terjadi Kesalahan!'
                })
            }
        }).catch((error) => {
            const userFacingError = getUserFacingError(error, 'Oops.. Terjadi Kesalahan!')
            SweetAlert({
                icon: 'error',
                text: userFacingError.message
            })
        }).finally(() => {
            setLoading(false)
        })
    }

    const addJob = () => {
        setJob([...job, {
            position: "",
            company_name: "",
            start_month: "",
            start_year: "",
            end_month: "",
            end_year: "",
            jobdesc: "",
            isNew: true
        }])
    }

    const deleteJob = (idx:number) => {
        setJob([...job].filter((x, i) => i!==idx))
    }

    const validateBeforeSubmit = () => {
        if (!form.fullname?.trim()) {
            SweetAlert({
                icon: 'error',
                text: "Nama Lengkap harus diisi"
            })
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false
        }

        if (!form.email?.trim()) {
            SweetAlert({
                icon: 'error',
                text: "Email harus diisi"
            })
            return false
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if (!emailPattern.test((form.email || '').trim())) {
            SweetAlert({
                icon: 'error',
                text: "Email tidak valid"
            })
            return false
        }

        if (!form.gender) {
            SweetAlert({
                icon: 'error',
                text: "Jenis Kelamin harus diisi"
            })
            return false
        }

        if (!form.birth_date?.trim()) {
            SweetAlert({
                icon: 'error',
                text: "Tanggal Lahir harus diisi"
            })
            return false
        }

        if (!form.age) {
            SweetAlert({
                icon: 'error',
                text: "Umur harus diisi"
            })
            return false
        }

        if (!form.domicile?.trim()) {
            SweetAlert({
                icon: 'error',
                text: "Domisili harus diisi"
            })
            return false
        }

        if (!form.phone?.trim()) {
            SweetAlert({
                icon: 'error',
                text: "No. Handphone (WA) harus diisi"
            })
            return false
        }

        if (form.position_loker_ids.length === 0) {
            SweetAlert({
                icon: 'error',
                text: "Posisi pekerjaan wajib dipilih"
            })
            return false
        }

        if (form.position_loker_ids.length > 1) {
            SweetAlert({
                icon: 'error',
                text: "Hanya boleh memilih 1 posisi pekerjaan"
            })
            return false
        }

        if (!form.photo?.trim()) {
            SweetAlert({
                icon: 'error',
                text: "Photogrid harus diisi"
            })
            setTimeout(() => {
                const photogridSection = document.querySelector('.photogrid-section');
                if (photogridSection) {
                    photogridSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
            return false
        }

        if (!form.cv?.trim()) {
            SweetAlert({
                icon: 'error',
                text: "CV harus diisi"
            })
            setTimeout(() => {
                const cvSection = document.querySelector('.cv-section');
                if (cvSection) {
                    cvSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
            return false
        }

        if (!form.agreement || !form.agreement2) {
            SweetAlert({
                icon: 'error',
                text: "Anda harus menyetujui Ketentuan Layanan, Kebijakan Privasi, dan pernyataan tidak menggunakan hijab"
            })
            setTimeout(() => {
                const agreementSection = document.querySelector('.agreement-section');
                if (agreementSection) {
                    agreementSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
            return false
        }

        return true
    }

    const validateJob = () => {
        if (job.length === 0) {
            return true;
        }

        const hasFilledMainForm = form.fullname?.trim() && form.position.length > 0;

        if (job.length > 1) {
            for (let i = 0; i < job.length; i++) {
                const j = job[i];

                const anyFilled = j.position || j.company_name || j.start_month || j.start_year || j.end_month || j.end_year || j.jobdesc;
                const allFilled = j.position && j.company_name && j.start_month && j.start_year && j.end_month && j.end_year && j.jobdesc;
                const isEmpty = !j.position && !j.company_name && !j.start_month && !j.start_year && !j.end_month && !j.end_year && !j.jobdesc;

                if (anyFilled && !allFilled) {
                    SweetAlert({
                        icon: 'error',
                        text: `Riwayat pekerjaan ${i + 1} belum lengkap. Lengkapi semua field atau hapus dengan tombol merah.`
                    });
                    return false;
                }

                if (isEmpty) {
                    SweetAlert({
                        icon: 'error',
                        text: `Riwayat pekerjaan ${i + 1} belum diisi. Lengkapi semua field atau hapus dengan tombol merah.`
                    });
                    return false;
                }
            }
        } else {
            const j = job[0];
            const anyFilled = j.position || j.company_name || j.start_month || j.start_year || j.end_month || j.end_year || j.jobdesc;
            const allFilled = j.position && j.company_name && j.start_month && j.start_year && j.end_month && j.end_year && j.jobdesc;
            const isEmpty = !j.position && !j.company_name && !j.start_month && !j.start_year && !j.end_month && !j.end_year && !j.jobdesc;

            if (anyFilled && !allFilled) {
                SweetAlert({
                    icon: 'error',
                    text: `Riwayat pekerjaan 1 belum lengkap. Lengkapi semua field atau hapus dengan tombol merah.`
                });
                return false;
            }

            if (isEmpty) {
                if (hasFilledMainForm) {
                    SweetAlert({
                        icon: 'error',
                        text: `Riwayat pekerjaan belum diisi. Isi riwayat pekerjaan atau hapus dengan tombol merah.`
                    });
                    return false;
                }
            }
        }

        return true;
    }

    useEffect(() => {
        loadCity()
        loadPosition()
    }, [jobId])

    useEffect(() => {
        const authUser = readAuthUser<AuthUserProfile>()
        if (!authUser) return

        setForm((current: any) => ({
            ...current,
            fullname: current.fullname || String(authUser.fullname || '').trim(),
            email: current.email || String(authUser.email || '').trim(),
            phone: current.phone || String(authUser.phone || '').trim(),
        }))
    }, [])

    useEffect(() => {
        if (!jobId || profileApplyAttemptedRef.current) {
            setProfileCheckLoading(false)
            return
        }

        profileApplyAttemptedRef.current = true
        applicationService.getCandidateProfile()
            .then(async (profileResponse) => {
                const profile = profileResponse.data?.data
                if (!profile) return

                const applyResponse = await applicationService.apply(Number(jobId))
                navigate("/terima-kasih", {
                    replace: true,
                    state: {
                        key: "talent-form",
                        from: "profile-reuse",
                        jobId: Number(jobId),
                        outsourceId: applyResponse.data.outsource_id,
                        applicationId: applyResponse.data.application_id,
                    }
                })
            })
            .catch((error: any) => {
                const payload = error?.response?.data
                if (payload?.needs_profile) return

                if (payload?.already_applied) {
                    navigate(`/lowongan-kerja/${jobId}`, { replace: true })
                    return
                }

                const userFacingError = getUserFacingError(error, 'Profil kandidat belum dapat diperiksa.')
                SweetAlert({ icon: 'error', text: userFacingError.message })
            })
            .finally(() => setProfileCheckLoading(false))
    }, [jobId, navigate])

    useEffect(() => {
        if (!jobId) return
        http.get(`jobs/${jobId}`)
            .then((res) => {
                const j = res.data?.data
                if (j) {
                    setJobInfo({ title: j.title, status: j.status || 'published' })
                    if (j.status === 'closed') {
                        setJobClosed(true)
                    }
                }
            })
            .catch(() => {
                // silently fail; form still usable without job context
            })
    }, [jobId])

    if (profileCheckLoading) {
        return (
            <div className="py-5 text-center">
                <ButtonLoading variant="brand" disabled loading="true">
                    <strong>Memeriksa profil kandidat...</strong>
                </ButtonLoading>
            </div>
        )
    }

    return(
        <div className="pt-5 pb-5">
            <Container>
                <Card>
                    <Card.Header className="bg-brand-opacity"><strong className="text-brand2">FORMULIR PENDAFTARAN</strong>
                        <div className="header mt-4">
                            Pendaftaran Lowongan Pekerjaan TEMA
                            {jobInfo && <span className="ms-2 text-brand2">— {jobInfo.title}</span>}
                        </div>
                        <p className="mt-4">Form ini digunakan untuk melakukan pendataan kandidat yang berminat dan ingin bergabung dengan tim kami. Silahkan isi data  dibawah ini dengan lengkap dan benar.</p>
                    </Card.Header>
                    <Card.Body>
                        {jobClosed && (
                            <div className="alert alert-danger text-center mb-4" role="alert">
                                <strong>Lowongan ini sudah ditutup.</strong> Kuota pendaftar telah penuh atau lowongan telah dinonaktifkan.
                            </div>
                        )}
                        <PhotoProvider maskOpacity={.7}>
                            <Form onSubmit={onSubmit} noValidate onInvalid={(e) => e.preventDefault()}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Nama Lengkap<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="fullname"
                                                autoComplete="name"
                                                placeholder="Masukan Nama Lengkap"
                                                value={form.fullname}
                                                onChange={(event) => setForm((state:any) => ({...state, fullname: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Email<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                autoComplete="email"
                                                placeholder="Masukan Email"
                                                value={form.email}
                                                onChange={(event) => setForm((state:any) => ({...state, email: event.target.value}))}
                                                readOnly
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Jenis Kelamin<span className="text-danger"> *</span></strong></Form.Label>
                                            <div className="d-flex flex-row gap-4">
                                                <Form.Check
                                                    type={"radio"}
                                                    label={"Laki-laki"}
                                                    checked={form.gender === "male"}
                                                    onChange={(event) => setForm((state:any) => ({...state, gender: "male"}))}
                                                />
                                                <Form.Check
                                                    type={"radio"}
                                                    label={"Perempuan"}
                                                    checked={form.gender === "female"}
                                                    onChange={(event) => setForm((state:any) => ({...state, gender: "female"}))}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Tanggal Lahir<span className="text-danger"> *</span></strong></Form.Label>
                                            <DateRangePicker
                                                initialSettings={{
                                                    singleDatePicker: true,
                                                    autoUpdateInput: false,
                                                    showDropdowns: true,
                                                    locale: {
                                                        applyLabel: "Terapkan",
                                                        cancelLabel: "Batal"
                                                    }
                                                }}
                                                onCallback={(start) => setForm((state:any) => ({...state, birth_date: moment(start).format("YYYY-MM-DD")}))}
                                            >
                                                <Form.Control
                                                    placeholder="Tanggal Lahir"
                                                    value={form.birth_date || ""}
                                                    disabled={loading}
                                                    readOnly
                                                />
                                            </DateRangePicker>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Umur<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Masukan Umur"
                                                value={form.age}
                                                onChange={(event) => setForm((state:any) => ({...state, age: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Domisili<span className="text-danger"> *</span></strong></Form.Label>
                                            <Select
                                                placeholder="Pilih Domisili" 
                                                options={city} 
                                                onChange={(selected:any) => {
                                                    if (selected) {
                                                        setForm((state:any) => ({...state, domicile: selected.label}))
                                                    }
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Username Instagram/Facebook<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Masukan Username Instagram/Facebook"
                                                value={form.socmed_url}
                                                onChange={(event) => setForm((state:any) => ({...state, socmed_url: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">No. Handphone (WA)<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Control
                                                type="tel"
                                                name="phone"
                                                autoComplete="tel"
                                                placeholder="Masukan No. Handphone (WA)"
                                                value={form.phone}
                                                onChange={(event) => setForm((state:any) => ({...state, phone: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Posisi Pekerjaan Apa Yang Kamu Cari?<span className="text-danger"> *</span></strong></Form.Label>
                                            <Select
                                                placeholder="Pilih posisi pekerjaan"
                                                options={position.map((item:any) => ({
                                                    value: item.position_loker_id,
                                                    label: item.position_loker_name,
                                                }))}
                                                value={position
                                                    .map((item:any) => ({ value: item.position_loker_id, label: item.position_loker_name }))
                                                    .find((opt:any) => opt.value === form.position_loker_ids[0]) || null}
                                                onChange={(selected:any) => {
                                                    const id = selected ? selected.value : null
                                                    setForm((state:any) => ({
                                                        ...state,
                                                        position_loker_ids: id ? [id] : [],
                                                    }))
                                                }}
                                                isDisabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Tinggi Badan (cm)<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Masukan Tinggi Badan"
                                                value={form.height}
                                                onChange={(event) => setForm((state:any) => ({...state, height: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Berat Badan (kg)<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Masukan Berat Badan"
                                                value={form.weight}
                                                onChange={(event) => setForm((state:any) => ({...state, weight: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Darimana Kamu Mendapat Info Lowongan Ini?<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Masukan Data"
                                                value={form.resource}
                                                onChange={(event) => setForm((state:any) => ({...state, resource: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {/* <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Keahlian<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Text muted></Form.Text>
                                            <InputTag
                                                tags={form.skill}
                                                onChange={(tags) => setForm((state:any) => ({ ...state, skill: tags}))}
                                            />
                                        </Form.Group>
                                    </Col> */}
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Deskripsikan Diri Anda<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Text muted> Pengalaman, Hobi, Keahlian, dll</Form.Text>
                                            <Form.Control
                                                type="text"
                                                as="textarea"
                                                placeholder="Masukan Deskripsi"
                                                value={form.description}
                                                onChange={(event) => setForm((state:any) => ({...state, description: event.target.value}))}
                                                disabled={loading}
                                                rows={7}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <hr/>
                                    <Col md={12} className="mb-3 job-history-section">
                                        <div className="title text-brand"><strong>Riwayat Pekerjaan</strong></div>
                                    </Col>
                                    <Col md={12}>
                                        
                                        {
                                            job.map((item, index) => {
                                                return(
                                                    <div key={"edu-"+index} className="d-flex flex-row gap-3 align-items-start mb-4">
                                                        <Row>
                                                            <Col md={6} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label><strong className="text-black">Posisi<span className="text-danger"> *</span></strong></Form.Label>
                                                                    <Form.Control
                                                                        placeholder="Masukan Posisi"
                                                                        value={item.position}
                                                                        onChange={(event) => {
                                                                            const dataJob = job.map((row, idx) => idx === index ? 
                                                                            {...row, position: event.target.value, isNew: false} 
                                                                            : row)

                                                                            setJob(dataJob)
                                                                        }}
                                                                        disabled={loading}
                                                                       
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label><strong className="text-black">Nama Perusahaan/Brand<span className="text-danger"> *</span></strong></Form.Label>
                                                                    <Form.Control
                                                                        placeholder="Masukan Nama Perusahaan"
                                                                        value={item.company_name}
                                                                        onChange={(event) => {
                                                                            const dataJob = job.map((row, idx) => idx === index ? 
                                                                            {...row, company_name: event.target.value, isNew: false} 
                                                                            : row)

                                                                            setJob(dataJob)
                                                                        }}
                                                                        disabled={loading}
                                                                     
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label><strong className="text-black">Periode Bekerja</strong></Form.Label>
                                                                    <Row>
                                                                        <Col xs={6} md={5}>
                                                                            <Select
                                                                                placeholder="Bulan" 
                                                                                options={month} 
                                                                                onChange={(selected:any) => {
                                                                                    if (selected) {
                                                                                        const dataJob = job.map((row, idx) => idx === index ? 
                                                                                        {...row, start_month: selected.value, isNew: false} 
                                                                                        : row)

                                                                                        setJob(dataJob)
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                        <Col xs={6} md={5}>
                                                                            <Select
                                                                                placeholder="Tahun" 
                                                                                options={yearRange(1980).map((x, y) => ({ label: x, value: x }))} 
                                                                                onChange={(selected:any) => {
                                                                                    if (selected) {
                                                                                        const dataJob = job.map((row, idx) => idx === index ? 
                                                                                        {...row, start_year: selected.value, isNew: false} 
                                                                                        : row)

                                                                                        setJob(dataJob)
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={6}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label><strong className="text-black">Sampai</strong></Form.Label>
                                                                    <Row>
                                                                        <Col xs={6} md={5}>
                                                                            <Select
                                                                                placeholder="Bulan" 
                                                                                options={month} 
                                                                                onChange={(selected:any) => {
                                                                                        if (selected) {
                                                                                            const dataJob = job.map((row, idx) => idx === index ? 
                                                                                            {...row, end_month: selected.value, isNew: false} 
                                                                                            : row)

                                                                                            setJob(dataJob)
                                                                                        }
                                                                                    }}
                                                                            />
                                                                        </Col>
                                                                        <Col xs={6} md={5}>
                                                                            <Select
                                                                                placeholder="Tahun" 
                                                                                options={yearRange(1980).map((x, y) => ({ label: x, value: x }))} 
                                                                                onChange={(selected:any) => {
                                                                                        if (selected) {
                                                                                            const dataJob = job.map((row, idx) => idx === index ? 
                                                                                            {...row, end_year: selected.value, isNew: false} 
                                                                                            : row)

                                                                                            setJob(dataJob)
                                                                                        }
                                                                                    }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col md={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label><strong className="text-black">Event</strong></Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        as="textarea"
                                                                        placeholder="Masukan Deskripsi"
                                                                        value={item.jobdesc}
                                                                        onChange={(event) => {
                                                                            const dataJob = job.map((row, idx) => idx === index ? 
                                                                            {...row, jobdesc: event.target.value, isNew: false} 
                                                                            : row)

                                                                            setJob(dataJob)
                                                                        }}
                                                                        disabled={loading}
                                                                        rows={4}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>&nbsp;</Form.Label>
                                                            <Button variant="danger" disabled={loading} onClick={() => deleteJob(index)}><MdClose/></Button>
                                                        </Form.Group>
                                                    </div>
                                                )
                                            })
                                        }
                                    </Col>
                                    <Col md={12} className="mb-3">
                                        <Button variant="brand" disabled={loading} onClick={() => addJob()}>Tambah Pekerjaan</Button>
                                    </Col>
                                    
                                    <hr/>
                                    <Col md={12} className="mb-3">
                                        <div className="title text-brand"><strong>Pendidikan Terakhir</strong></div>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Jenjang Pendidikan</strong></Form.Label>
                                            <Form.Control
                                                placeholder="Masukan Jenjang Pendidikan"
                                                value={form.level}
                                                onChange={(event) => setForm((state:any) => ({...state, education_level: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Jurusan</strong></Form.Label>
                                            <Form.Control
                                                placeholder="Masukan Jurusan"
                                                value={form.major}
                                                onChange={(event) => setForm((state:any) => ({...state, education_major: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Nama Intansi/Sekolah</strong></Form.Label>
                                            <Form.Control
                                                placeholder="Masukan Nama Intansi/Sekolah"
                                                value={form.intitute}
                                                onChange={(event) => setForm((state:any) => ({...state, education_institute: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Lokasi Intansi/Sekolah</strong></Form.Label>
                                            <Form.Control
                                                placeholder="Masukan Lokasi Intansi/Sekolah"
                                                value={form.location}
                                                onChange={(event) => setForm((state:any) => ({...state, education_location: event.target.value}))}
                                                disabled={loading}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label><strong className="text-black">Lulus Tahun</strong></Form.Label>
                                            <Select
                                                placeholder="Pilih Tahun" 
                                                options={yearRange(1980).map((x, y) => ({ label: x, value: x }))} 
                                                onChange={(selected:any) => setForm((state:any) => ({...state, education_year_end: selected.label}))}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <hr/>

                                    <Col md={6}>
                                        <Form.Group className="mb-3 photogrid-section">
                                            <Form.Label><strong className="text-black">Photogrid (Nama/TB/BB)<span className="text-danger"> *</span></strong></Form.Label>
                                            <Form.Text muted> Contoh: (Nabila/163/55)</Form.Text>
                                            <br/>
                                            <Form.Text muted>Harap upload photo full body tanpa menggunakan hijab seperti contoh dibawah.</Form.Text>
                                            <div className="d-flex flex-row flex-wrap gap-3">
                                                <PhotoView src={imgPhotogrid}>
                                                    <img src={imgPhotogrid} width="200px" className="pointer" alt=""/>
                                                </PhotoView>
                                                <div style={{flex:1, height: "200px"}}>
                                                    <ImageUploader
                                                        value={form.photo}
                                                        onChange={(img) => setForm((state:any) => ({ ...state, photo: img }))}
                                                    />
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3 cv-section">
                                            <Form.Label><strong className="text-black">CV<span className="text-danger"> *</span></strong></Form.Label>
                                            <FileUploader
                                                accept=".pdf,.doc,.docx,.txt,.pdfx"
                                                value={form.cv}
                                                onChange={(url) => setForm((state:any) => ({ ...state, cv: url }))}
                                                desc="(Type of file: pdf, doc, docx, txt, pdfx)"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={12} className="agreement-section">
                                        <div className="d-flex flex-row gap-2">
                                            <Form.Check
                                                type={"checkbox"}
                                                checked={form.agreement}
                                                onChange={() => setForm((state:any) => ({...state, agreement: !form.agreement}))}
                                            />
                                            <p className="flex-fill">
                                                Dengan ini saya menyetuji <a href="/ketentuan-layanan" target="_blank" className="text-brand">Ketentuan Layanan</a> & <a href="/kebijakan-privasi" target="_blank" className="text-brand">Kebijakan Privasi</a> yang berlaku.
                                            </p>
                                        </div>
                                        <div className="d-flex flex-row gap-2" style={{marginTop:-10}}>
                                            <Form.Check
                                                type={"checkbox"}
                                                checked={form.agreement2}
                                                onChange={() => setForm((state:any) => ({...state, agreement2: !form.agreement2}))}
                                            />
                                            <p className="flex-fill">
                                                Saya bersedia tanpa menggunakan hijab pada saat bekerja.
                                            </p>
                                        </div>
                                    </Col>
                                    <Col md={12} className="mt-4">
                                        <ButtonLoading type="submit" variant="brand" disabled={!form.agreement || !form.agreement2} loading={loading.toString()}><strong>Kirim</strong></ButtonLoading>
                                    </Col>
                                </Row>
                            </Form>
                        </PhotoProvider>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    )
}

export default TalentForm
